<ion-chip [ngClass]="customClass ? customClass : ''"
[style.--background]="bgColor"
[style.border-color]="borderColor"
class="min-h-[20px] md:min-h-[26px] m-0"
>
  <ng-content ></ng-content>
</ion-chip>
